import {
  Trash2,
  Pencil,
  Send,
  RefreshCcw,
  PencilLine,
  Search,
  File,
  Clipboard,
  ClipboardList,
  Folder,
  FolderOpen,
  Calendar,
  Plus,
  Minus,
  Ellipsis,
  EllipsisVertical,
  XCircle,
  FileSpreadsheet,
  FileX,
  Link,
  Unlink,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronUp,
  ChevronDown,
  ChevronsUpDown,
  Info,
  Grip,
  Eye,
  LogIn,
  ThumbsUp,
  ThumbsDown,
  ArrowBigUp,
  ArrowBigDown,
  SquareX,
  SquareCheck,
  Check,
  X,
  SquareCheckBig,
  Grid2x2Check,
  CircleMinus,
  CircleAlert,
  ClockFading,
  CircleCheck,
  AirVent,
  Workflow,
  Printer,
  CornerDownRight,
  Undo,
  ShieldCheck,
  Boxes,
  KeyRound,
  Pause,
  Play,
  CircleStop,
  Terminal,
  Users,
  UserLock,
  Clock,
  ExternalLink
} from 'lucide-static';

const iconMap = {
  trash: Trash2,
  pencil: Pencil,
  send: Send,
  'refresh-ccw': RefreshCcw,
  'pencil-line': PencilLine,
  search: Search,
  file: File,
  clipboard: Clipboard,
  'clipboard-list': ClipboardList,
  folder: Folder,
  'folder-open': FolderOpen,
  calendar: Calendar,
  plus: Plus,
  minus: Minus,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  xcircle: XCircle,
  xls: FileSpreadsheet,
  pdf: FileX,
  link: Link,
  unlink: Unlink,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevrons-left': ChevronsLeft,
  'chevrons-right': ChevronsRight,
  'chevron-up': ChevronUp,
  'chevron-down': ChevronDown,
  'chevrons-up-down': ChevronsUpDown,
  info: Info,
  grip: Grip,
  eye: Eye,
  login: LogIn,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'arrow-big-up': ArrowBigUp,
  'arrow-big-down': ArrowBigDown,
  'square-x': SquareX,
  check:Check,
  x:X,
  'square-check': SquareCheck,
  'square-check-big': SquareCheckBig,
  'grid-2x2-check': Grid2x2Check,
  'circle-minus': CircleMinus,
  'circle-alert': CircleAlert,
  'clock-fading': ClockFading,
  'circle-check': CircleCheck,
  'air-vent': AirVent,
  'workflow': Workflow,
  'printer': Printer,
  'corner-down-right':CornerDownRight,
  'undo':Undo,
  'shield-check':ShieldCheck,
  'boxes':Boxes,
  'key-round':KeyRound,
  pause: Pause,
  play: Play,
  'circle-stop':CircleStop,
  'terminal':Terminal,
  'users':Users,
  'user-lock':UserLock,
  'clock':Clock,
  'external-link':ExternalLink
};

export const lucideIcon = (name: keyof typeof iconMap,size:number=18) => {
  return iconMap[name].replace('width="24"', 'width="'+size+'"')
                                 .replace('height="24"', 'height="'+size+'"') || '';
};